import { Checkbox, Flex, Grid, GridItem, Link, Text, VStack, useDisclosure } from "@chakra-ui/react";
import { InputControl, TextArea } from "src/common/formConstants";

import { ConfirmationForm } from "src/types/FormTypes";
import { PrivacyModal } from "./PrivacyModal";
import { Regisration_Form_Labels_English } from "src/common/constants/englishLabels";
import { Regisration_Form_Labels_Hindi } from "src/common/constants/hindiLabels";
import { RootState } from "src/store/store";
import { useSelector } from "react-redux";

type ConfirmationDetailsProps = {
  isCurrentFormValid: boolean;
  handleConfirmationChanged: (fieldName: string, value: string | boolean) => void;
  confirmationValues: ConfirmationForm;
}

const ConfirmationDetails: React.FC<ConfirmationDetailsProps> = (props: ConfirmationDetailsProps) => {
  const { isCurrentFormValid, handleConfirmationChanged, confirmationValues } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  return (
    <VStack w="100%">
      <Grid  width="100%" mb={8} templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={10}>
        <GridItem>
          <InputControl isMandatory={true} isValidate={isCurrentFormValid} name="qualification" placeholder="Select your highest educational qualification" onChange={handleConfirmationChanged} value={confirmationValues?.qualification} hindiLabel={Regisration_Form_Labels_Hindi.EDUCATIONAL_QUALIFICATION} englishLabel={Regisration_Form_Labels_English.EDUCATIONAL_QUALIFICATION} />
        </GridItem>
        <GridItem>
          <InputControl isMandatory={true} isValidate={isCurrentFormValid} placeholder="Select your occupation" name="occupation" onChange={handleConfirmationChanged} value={confirmationValues?.occupation} hindiLabel={Regisration_Form_Labels_Hindi.OCCUPATION} englishLabel={Regisration_Form_Labels_English.OCCUPATION} />
        </GridItem>
      </Grid>
      <TextArea placeholder="Describe your business in 200 words (minimum)" name="businessDetails" onChange={handleConfirmationChanged} value={confirmationValues?.businessDetails} hindiLabel={Regisration_Form_Labels_Hindi.BUSINESS_DETAILS} englishLabel={Regisration_Form_Labels_English.BUSINESS_DETAILS} />
      <Flex mt={8} alignItems="center">
        <Checkbox
          sx={{
            "& .chakra-checkbox__control": {
              borderRadius: "0",
              borderColor: "#FF7E6B"
            },
            "& .chakra-checkbox__control[data-checked]": {
              bg: "#FF7E6B",
              borderColor: "#FF7E6B"
            },
            "& .chakra-checkbox__control[data-checked]:hover": {
              bg: "#FF7E6B",
              borderColor: "#FF7E6B"
            },
            "& .chakra-checkbox__control:hover": {
              bg: "#FF7E6B",
            },
          }}
          size='md'
          mb={1}
          onChange={(event) => handleConfirmationChanged("isPolicyConfirmed", event.target.checked)}
          mr={2} />
        <Text
          fontFamily="PP Neue Montreal"
          fontSize="20px"
          mb={1}
          className="form-text"
          color="#6C757D"
        >
          {isHindiLabels ?
            Regisration_Form_Labels_Hindi.POLICY
            : <>
              I agree to all <Link onClick={onOpen} textDecoration="underline" _hover={{ textColor: "#FF7E6B" }}>privacy policy</Link> of the organization</>}
        </Text>
      </Flex>
      {isOpen && <PrivacyModal isOpen={isOpen} onClose={onClose} />}
    </VStack>
  )
}

export default ConfirmationDetails;
